// extracted by mini-css-extract-plugin
export default {"tag":"dark_tag__4iueI color_colorDarkSelect__vvg7x"};